import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';
import { ButtonLink } from '../shared/ui/button';
import { Wordmark } from '../shared/ui/wordmark';

export const SiteHeader = () => {
  const { t } = useTranslation();
  const { locale } = useParams();

  return (
    <header className="sticky top-0 z-40 border-b border-line bg-surface">
      <div className="mx-auto flex h-16 w-full max-w-6xl items-center gap-4 px-4 sm:gap-6 sm:px-6">
        <Wordmark to={`/${locale}/`} />
        <nav aria-label={t('nav.mainLabel')} className="hidden sm:flex">
          <a
            href={`/${locale}/#pricing`}
            className="text-sm font-medium text-muted hover:text-accent-ink hover:underline hover:underline-offset-4"
          >
            {t('nav.pricing')}
          </a>
        </nav>
        <div className="ml-auto flex items-center gap-2 sm:gap-3">
          <Link
            to={`/${locale}/sign-in`}
            className="shrink-0 whitespace-nowrap px-1 py-2.5 text-sm font-semibold text-content hover:text-accent-ink hover:underline hover:underline-offset-4"
          >
            {t('nav.signIn')}
          </Link>
          <ButtonLink to={`/${locale}/sign-up`} className="shrink-0">
            {t('nav.primaryAction')}
          </ButtonLink>
        </div>
      </div>
    </header>
  );
};
